import React from 'react';
import { Clock } from 'lucide-react';
import { beverageSections, foodSections } from '../data/pavilionMenu';
import type { MenuSection } from '../types/hours';
import { SkewTag } from './SkewTag';
export function PavilionMenu() {
  return <section id="menu" aria-labelledby="menu-heading" className="bg-foodCream border-b-4 border-foodMaroon py-20 lg:py-24" data-id="element-250" data-mp="pfas0yimzwk6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251" data-mp="1i2olunr1gc02">
        <header className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14" data-id="element-252" data-mp="1i0aq0cojavrg">
          <div data-id="element-253" data-mp="1m1waaj3eecbo">
            <SkewTag tone="teal" shadow="orange" data-id="element-254" data-mp="1847qlel2hb87">
              New · Debuts This Weekend
            </SkewTag>
            <h2 id="menu-heading" className="font-wide text-5xl sm:text-6xl xl:text-7xl uppercase leading-[0.9] mt-7" data-id="element-255" data-mp="1d3288d7astqq">
              The Pavilion <span className="text-foodTeal" data-id="element-256" data-mp="3swj7xctt0mc9">Menu</span>
            </h2>
          </div>
          <div className="flex items-center gap-3 font-display font-wide font-extrabold uppercase text-lg" data-id="element-257" data-mp="1pggcka20e1i">
            <Clock size={22} aria-hidden="true" className="text-foodTeal shrink-0" data-id="element-258" data-mp="2mhhs9ilzirez" />
            <span data-id="element-259" data-mp="2ifmnu58rbxwz">
              <span className="text-foodOrange" data-id="element-260" data-mp="2ig69nx1j36ga">Mon</span> 9 AM – 2 PM
              <br data-id="element-261" data-mp="2wf5wcz5hdb9t" />
              <span className="text-foodOrange" data-id="element-262" data-mp="2wbi2fyw4imuk">Wed</span> 2 PM – 7 PM
            </span>
          </div>
        </header>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-start" data-id="element-263" data-mp="35e9dvyp01im7">
          <div className="lg:col-span-8 grid md:grid-cols-2 gap-x-10 gap-y-12" data-id="element-264" data-mp="35c6g2shlul6x">
            {foodSections.map(s => <FoodSection key={s.title} section={s} data-id="element-265" data-mp="3f42ooxhbhtpe" />)}
          </div>

          <aside aria-labelledby="beverages-heading" className="lg:col-span-4 bg-foodOrange border-4 border-foodMaroon shadow-[8px_8px_0px_0px_#015C68] p-7 sm:p-8" data-id="element-266" data-mp="3f5x11neiwdhv">
            <SkewTag as="h3" id="beverages-heading" tone="teal" shadow="gold" size="lg" data-id="element-267" data-mp="3ozvzabbh7d4j">
              Beverages
            </SkewTag>
            {beverageSections.map(s => <div key={s.title} className="mt-8" data-id="element-268" data-mp="3r86ohwlnwzy7">
                <h4 className="font-wide text-2xl uppercase text-foodMaroon mb-3" data-id="element-269" data-mp="3w4ot8wgzsyaj">
                  {s.title}
                </h4>
                <ul className="space-y-3" data-id="element-270" data-mp="4xkpcag59s6c">
                  {s.items.map(item => <li key={item.name} className="flex items-center justify-between gap-3" data-id="element-271" data-mp="9qniihh0ezm0">
                      <span className="text-lg font-bold text-white" data-id="element-272" data-mp="enx940g4xhbf">{item.name}</span>
                      <Price value={item.price} tone="teal" data-id="element-273" data-mp="ipshfowhguyp" />
                    </li>)}
                </ul>
              </div>)}
          </aside>
        </div>
      </div>
    </section>;
}
function FoodSection({
  section
}: {
  section: MenuSection;
}) {
  return <div data-id="element-274" data-mp="2pht9upnh11k8">
      <SkewTag as="h3" tone="orange" shadow="teal" size="lg" data-id="element-275" data-mp="2pi1p2o72giyl">
        {section.title}
      </SkewTag>
      {section.note && <p className="text-sm font-semibold italic text-foodMaroon/70 mt-4" data-id="element-276" data-mp="2ugcywyxd2tgt">
          {section.note}
        </p>}
      <ul className="mt-5 space-y-4" data-id="element-277" data-mp="2myetb5iaw2iv">
        {section.items.map(item => <li key={item.name} className="flex items-start justify-between gap-4" data-id="element-278" data-mp="2i4kbk7m99xmf">
            <span data-id="element-279" data-mp="2d7acs1cz89lx">
              <span className="block font-bold leading-snug" data-id="element-280" data-mp="2d4o5m2tzzw48">{item.name}</span>
              {item.note && <span className="block text-sm italic text-foodMaroon/70" data-id="element-281" data-mp="285ups3r8nt0w">
                  {item.note}
                </span>}
            </span>
            <Price value={item.price} tone="gold" data-id="element-282" data-mp="30xo5lu3dychk" />
          </li>)}
      </ul>
    </div>;
}
function Price({
  value,
  tone
}: {
  value: number;
  tone: 'gold' | 'teal';
}) {
  const color = tone === 'gold' ? 'bg-foodGold text-foodMaroon' : 'bg-foodTeal text-white';
  return <span aria-label={`$${value}`} className={`shrink-0 w-9 h-9 rounded-full ${color} flex items-center justify-center font-display font-extrabold`} data-id="element-283" data-mp="1kid4mr2hbt6w">
      {value}
    </span>;
}